import * as Scrivito from "scrivito";
import { BasePageClass } from "../Defaults/PageObjClass";

const HomepageClass = Scrivito.createObjClass({
  name: "Homepage",
  extends: BasePageClass,
  attributes: {
    contentArea: "widgetlist",
  },
});

Scrivito.provideObjClass("Homepage", HomepageClass);
